<template>
    <div class="modal fade" id="addEditCampaignGroup" tabindex="-1" role="dialog" aria-labelledby="addEditCampaignGroup" aria-hidden="true">
        <div class="modal-dialog modal-lg " role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Editing Campaign Group</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <!-- <h2 class="text-center">Editing Campaign Group</h2> -->
                    <div class="form-container">
                        <!-- form start-->
                        <form>
                            <div class="form-group">
                                <label>Campaign Group Name</label>
                                <input type="text" placeholder="Enter name" class="form-control"  />
                            </div>
                            <div class="form-group">
                                <label>D Budget($)</label>
                                <input type="text" placeholder="Enter amount" class="form-control" />
                            </div>
                            <div class="form-group">
                                <label>Strategy</label>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div id="sales" class="strategy">Sales are activities related to selling or the number of goods or services sold in a given time period.</div>
                                    </div>
                                    <div class="col-md-6">
                                        <div id="roi" class="strategy">Return on marketing investment or ROMI is a metric used in online marketing to measure the effectiveness of a marketing campaign.</div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <!-- form end-->
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary">Save changes</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">

</style>
